const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/duties",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    create({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/create`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    update({ dispatch, state, rootState }, { id, data }) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/update/${id}`,
            method: "PUT",
            data,
          },
          { root: true }
        );
      }
    },
    delete({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/${id}`,
            method: "DELETE",
          },
          { root: true }
        );
      }
    },

    profile({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/profile?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
  },
};
